/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import UserQueryResult from './UserQueryResult';

/**
 * The RankingQueryResultRanking model module.
 * @module model/RankingQueryResultRanking
 * @version 1.0
 */
class RankingQueryResultRanking {
    /**
     * Constructs a new <code>RankingQueryResultRanking</code>.
     * @alias module:model/RankingQueryResultRanking
     */
    constructor() { 
        
        RankingQueryResultRanking.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RankingQueryResultRanking</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RankingQueryResultRanking} obj Optional instance to populate.
     * @return {module:model/RankingQueryResultRanking} The populated <code>RankingQueryResultRanking</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RankingQueryResultRanking();

            if (data.hasOwnProperty('answeredMcEarnedSum')) {
                obj['answeredMcEarnedSum'] = ApiClient.convertToType(data['answeredMcEarnedSum'], 'Number');
            }
            if (data.hasOwnProperty('balance')) {
                obj['balance'] = ApiClient.convertToType(data['balance'], 'Number');
            }
            if (data.hasOwnProperty('calculatedAt')) {
                obj['calculatedAt'] = ApiClient.convertToType(data['calculatedAt'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('user')) {
                obj['user'] = UserQueryResult.constructFromObject(data['user']);
            }
        }
        return obj;
    }


}

/**
 * @member {Number} answeredMcEarnedSum
 */
RankingQueryResultRanking.prototype['answeredMcEarnedSum'] = undefined;

/**
 * @member {Number} balance
 */
RankingQueryResultRanking.prototype['balance'] = undefined;

/**
 * @member {String} calculatedAt
 */
RankingQueryResultRanking.prototype['calculatedAt'] = undefined;

/**
 * @member {String} date
 */
RankingQueryResultRanking.prototype['date'] = undefined;

/**
 * @member {module:model/UserQueryResult} user
 */
RankingQueryResultRanking.prototype['user'] = undefined;






export default RankingQueryResultRanking;

